export class Country {
	public constructor(
		public readonly identity: string,
		public readonly name: string,
		public readonly hasAreas: boolean,
		public readonly path: string,
		public readonly eea: boolean
	) {}
}
